import { useReducedMotion } from "framer-motion";
import { APP } from "../../constants/testIds";

const phrases = [
  "Ingredientes frescos",
  "Carta 2026",
  "Cocina de la casa",
  "Sabor de la tierra",
];

export const Marquee = () => {
  const prefersReduced = useReducedMotion();
  const items = [...phrases, ...phrases, ...phrases];

  return (
    <div
      data-testid={APP.marquee}
      className="relative border-y border-[#c9a961]/15 bg-[#0d0b08] py-6 sm:py-9 overflow-hidden select-none"
      aria-hidden
    >
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none noise-texture" />
      <div className={`flex gap-14 whitespace-nowrap will-change-transform ${prefersReduced ? "" : "marquee-track"}`}>
        {items.map((p, i) => (
          <span
            key={i}
            className="flex items-center gap-14 font-playfair text-3xl italic text-[#f4e9d5]/70 sm:text-4xl md:text-5xl"
          >
            {p}
            <span className="text-[#c9a961]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
